var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f-hamburger-switch",class:[_vm.cCssClass, `thickness${_vm.thickness}`],attrs:{"role":"switch"},on:{"click":_vm.toggle}},[_c('div',{staticClass:"cont"},[_c('div',{staticClass:"l1"}),(!_vm.twoLines)?_c('div',{staticClass:"l2"}):_vm._e(),_c('div',{staticClass:"l3"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }